import React from 'react';
import styled from 'styled-components';
import Icon from '../../../../components/Icon';
import CountryLabel from '../../../../components/CountryLabel';

const Source = styled.div`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-size: 12px;
  line-height: 1.83;
  color: #9b9b9b;
  position: relative;
  :hover > .tooltip {
    display: grid;
  }

  a {
    text-decoration: underline;
  }

  .title {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    line-height: 1.33;
    letter-spacing: 1.5px;
    color: #4a4a4a;
    text-transform: uppercase;
  }

  .icon {
    width: 18px;
    height: 18px;
    font-size: 12px;
    background-color: #aaa;
    color: white;
    border-radius: 50%;
  }

  .tooltip {
    max-width: 385px;
    display: none;
    grid-template-columns: 50% 50%;
    border-radius: 2px;
    border: solid 1px #e5eef5;
    background-color: #fff;
    padding: 20px 0px;
    position: absolute;
    left: -70px;
    top: 30px;
    ::after {
      content: '';
      width: 10px;
      height: 10px;
      background-color: white;
      border-bottom: solid 1px #e5eef5;
      border-right: solid 1px #e5eef5;
      position: absolute;
      transform: rotate(-135deg);
      top: -6px;
      left: 25%;
    }
  }

  .headerIcon {
    font-size: 10px;
    margin-right: 5px;
  }

  .column {
    padding: 0px 35px;
    white-space: nowrap;
  }

  .columnTitle {
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .country-country-label-title {
    font-size: 14px;
  }
  .socialItem {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 16px;
    color: #1f2b37;
  }

  .country-label-city {
    text-transform: uppercase;
  }

  .country-label-flag {
    height: 32px;
    margin-right: 6px;
    font-size: 21px;
  }

  .social {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    height: 25px;
    font-size: 16px;
  }

  .social > :last-child {
    margin-left: 10px;
  }

  .table {
    display: grid;
    grid-template-rows: 25px 25px 25px;
  }

  .itemCountry > * {
    margin-left: -28px;
  }

  .row {
    grid-column-start: 1;
    grid-column-end: 3;
    padding: 20px 10px 0px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    color: #1f2b37;
  }
`;

const formatToK = (n) => {
  let n_format = 0;
  let suffix = '';
  if (n > 0 && n < 1000) {
    n_format = Math.floor(n);
  } else if (n >= 1000 && n < 1000000) {
    n_format = n / 1000;
    suffix = 'K';
  } else if (n >= 1000000 && n < 1000000000) {
    n_format = n / 1000000;
    suffix = 'M';
  } else if (n >= 1000000000 && n < 1000000000000) {
    n_format = n / 1000000000;
    suffix = 'B';
  } else if (n >= 1000000000000) {
    n_format = n / 1000000000000;
    suffix = 'T';
  }

  let n_formated = `${n_format}${suffix}`;
  n_formated = n_formated.replace('.', ',');
  return n_formated;
};

const SourceLink = ({ title, area, digital, link, showTooltip = true }) => (
  <Source>
    <a className="title" href={link} target="_blank" rel="noopener noreferrer">
      {title}
    </a>
    {showTooltip && (
      <div className="tooltip">
        <div className="column">
          <span className="columnTitle">
            <Icon className="headerIcon" icon="world" />
            <p>Zone d’influence</p>
          </span>
          <ul className="table">
            {area &&
              area.map((item, key) => (
                <li className="itemCountry" key={`${item.name}-${key}`}>
                  <CountryLabel name={item.name} city={item.value} />
                </li>
              ))}
          </ul>
        </div>
        <div className="column">
          <span className="columnTitle">
            <Icon className="headerIcon" icon="shareResize" />
            <p>Influence digitale</p>
          </span>
          <ul className="table">
            {digital &&
              digital.map((item, key) => (
                <li className="socialItem" key={`${item.name}-${key}`}>
                  <span className="social">
                    <Icon icon={item.icon} />
                    <p>{formatToK(item.value)} abonnés</p>
                  </span>
                </li>
              ))}
          </ul>
        </div>
        {!link && (
          <div className="row">
            Le lien vers l’article source n’est pas valide, n’hésitez pas à nous
            contacter sur info@wine-services.com
          </div>
        )}
      </div>
    )}
  </Source>
);

export default SourceLink;
